import { httpClient } from './http-client';
import { createHTTP } from './http-creator';

export const createHTTPService = (prefix: string) => createHTTP(prefix, httpClient);
